var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAddToSlides(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.54,
    height: 42.432,
    viewBox: "0 0 54.54 42.432",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-6937.38-844.141v-7.236h-7.234v-3.66h7.234v-7.234h3.66v7.234h7.236v3.66h-7.236v7.236Zm-43.645-7.253V-881.32h33.811v29.926Zm2.856-2.856h28.1v-24.213h-28.1Zm9.48-4.794v-2.971h13.706v2.971Zm-6.4,0v-2.971h2.97v2.971Zm30.154-.117v-24.556H-6974.4v-2.856h32.325v27.412Zm-23.757-5.71v-2.97h13.706v2.97Zm-6.4,0v-2.97h2.97v2.97Zm6.4-5.939v-2.97h13.706v2.97Zm-6.4,0v-2.97h2.97v2.97Z",
    transform: "translate(6981.025 886.573)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddToSlides);
export default __webpack_public_path__ + "static/media/icon-add-to-slides.710d2a01.svg";
export { ForwardRef as ReactComponent };